import type { RouteRecordRaw } from 'vue-router'

const maintenanceRoutes: RouteRecordRaw[] = [
  {
    path: 'maintenance',
    name: 'maintenance',
    meta: {
      titleKey: 'routes.maintenance.title',
      icon: 'Tools',
      helpKey: 'maintenance'
    },
    redirect: { name: 'device-log' },
    children: [
      {
        path: 'device-log',
        name: 'device-log',
        component: () => import('@/views/maintenance/DeviceLog.vue'),
        meta: { titleKey: 'routes.maintenance.device-log.title', helpKey: 'device_log' }
      },
      {
        path: 'network-message',
        name: 'network-message',
        component: () => import('@/views/maintenance/NetworkMessage.vue'),
        meta: { titleKey: 'routes.maintenance.network-message.title', helpKey: 'network_message' }
      },
      {
        // T-079 / A3：非事件日志（协议解析失败原文 + 系统运行日志）。
        // 与「设备消息」（查 event_store）**数据源不同**：本页查 non_event_logs。
        path: 'non-event-log',
        name: 'non-event-log',
        component: () => import('@/views/maintenance/NonEventLog.vue'),
        meta: { titleKey: 'routes.maintenance.non-event-log.title', helpKey: 'non_event_log' }
      },
      {
        path: 'device-error',
        name: 'device-error',
        component: () => import('@/views/maintenance/DeviceError.vue'),
        meta: { titleKey: 'routes.maintenance.device-error.title', helpKey: 'device_error' }
      },
      {
        path: 'firmware-ota',
        name: 'firmware-ota',
        component: () => import('@/views/maintenance/FirmwareOTA.vue'),
        meta: { titleKey: 'routes.maintenance.firmware-ota.title', helpKey: 'firmware_ota' }
      },
      {
        path: 'batch-config',
        name: 'batch-config',
        component: () => import('@/views/maintenance/BatchConfig.vue'),
        meta: { titleKey: 'routes.maintenance.batch-config.title', helpKey: 'batch_config' }
      }
    ]
  }
]

export default maintenanceRoutes
